import React from "react";
import Contact from "../Contact/contact";

// The project decks close on the same block as the home page. Kept as its own
// module so the six deck pages' imports stay untouched.
const Footer = (props) => <Contact variant="deck" {...props} />;

export default Footer;
